import 'zone.js';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

// Public enrollment subdomain (matricula.*) lands straight on the funnel: rewrite
// the root URL before Angular boots so it navigates directly to /matricula.
if (window.location.hostname.startsWith('matricula.') && window.location.pathname === '/') {
	window.history.replaceState(null, '', `/matricula${window.location.search}`);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
	console.error(err);
});
// deploy test PINAAR staging 2026-10-31
